import React, { Component, PropTypes } from 'react';
import { lang } from '../../strings';

export default class SimCardActivateDialog extends Component {

   render() {
      let {onConfirm, onCancel} = this.props;

      return (
         <div className="mp-popup-container">
            <div className="mp-popup-content">
               <a href="#" className="mp-close" onClick={onCancel}>&times;</a>
               <h2 className="h5 color-dark-blue">{lang.simCard.activate.title}</h2>
               <p>{lang.simCard.activate.intro}</p>

               <div className="mp-block">
                  <div className="mp-block-half">
                     <button type="button" className="mp-submit" onClick={onConfirm}>{lang.simCard.activate.button}</button>
                  </div>
                  <div className="mp-block-half">
                     <button type="button" className="mp-submit" onClick={onCancel}>{lang.simCard.activate.cancel}</button>
                  </div>
               </div>
            </div>
         </div>
      );
   }
}

SimCardActivateDialog.propTypes = {
   onConfirm: PropTypes.func.isRequired,
   onCancel: PropTypes.func.isRequired
};